import { Flex, Image, Layout } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { useEffect, type ReactNode } from "react";

import { Link } from "react-router";
import IMAGES from "../assets/images";
import { ENV_CONFIG } from "../config/global.config";
import { cn } from "../utils/global.utils";
import NotificationMenu from "./_components/NotificationMenu";
import ProfileMenu from "./_components/ProfileMenu";
import Sidebar from "./_components/Sidebar";

type Props = {
  children: ReactNode;
  title: string;
};

const DashboardLayout = ({ children, title }: Props) => {
  // const [collapsed, setCollapsed] = useState(
  //   JSON.parse(localStorage.getItem("collapsed") || "false")
  // );

  // useEffect(() => {
  //   localStorage.setItem("collapsed", JSON.stringify(collapsed));
  // }, [collapsed]);

  useEffect(() => {
    document.title = `${title} | ${ENV_CONFIG.APP_NAME}`;
  }, [title]);

  return (
    <Layout className="min-h-screen custom-sidebar">
      {/* Navbar */}
      <Header
        className="!bg-white !px-4 flex items-center justify-between h-20  relative  shadow-md"
        // style={{
        //   boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        // }}
      >
        <div>
          <Link to="/admin/dashboard">
            <Flex align="center" className={cn("h-20")}>
              <Image
                preview={false}
                alt="Vendor Management System"
                src={IMAGES.logo}
                className="!h-12"
              />
            </Flex>
          </Link>

          {/* <button onClick={() => setCollapsed((prev: boolean) => !prev)}>
            {<TogglerIcon />}
          </button> */}
        </div>

        <Flex gap={24} align="center">
          <NotificationMenu />
          <ProfileMenu />
        </Flex>
      </Header>

      {/* Main Content */}
      <Layout>
        {/* Sidebar */}
        <Sidebar />

        {/* Body Content */}
        <Content className="p-6 h-[calc(100vh_-_85px)] bg-theme-slate-25 overflow-x-hidden overflow-y-scroll">
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
